import { Pillar, ProcessStep } from './types';
import { CASE_STUDIES as MODULAR_CASE_STUDIES } from './data/case-studies';

export const CASE_STUDIES = MODULAR_CASE_STUDIES;

export const PILLARS: Pillar[] = [
  {
    icon: 'palette',
    title: 'Design-First',
    description: 'Bold, funky, and editorial aesthetics that command attention. We believe software should be as beautiful as a high-end magazine.'
  },
  {
    icon: 'terminal',
    title: 'Engineering',
    description: 'Scalable, performant codebases built with modern stacks. We prioritize speed, security, and long-term maintainability.'
  },
  {
    icon: 'touch_app',
    title: 'UX Focus',
    description: 'Intuitive flows designed for real-life usage. We solve complex problems with simple, delightful user journeys.'
  }
];

export const PROCESS_STEPS: ProcessStep[] = [
  {
    number: '01',
    title: 'Discovery',
    description: 'We dive deep into your vision, market, and user needs to build a rock-solid foundation for the project.',
    icon: 'search'
  },
  {
    number: '02',
    title: 'Design',
    description: 'Iterative wireframing and high-fidelity UI design to create a funky, cohesive visual identity.',
    icon: 'edit_square'
  },
  {
    number: '03',
    title: 'Development',
    description: 'Turning designs into high-performance code with a focus on responsiveness and smooth interactions.',
    icon: 'code'
  },
  {
    number: '04',
    title: 'Deployment',
    description: 'Rigorous testing followed by a seamless launch and ongoing support to ensure long-term success.',
    icon: 'check_circle'
  }
];